<div class="bg-lightest-blue border border-light-navy rounded px-4 py-6 grid grid-cols-12 gap-4">
    <div class="bg-navy text-white font-bold rounded-full w-7 h-7 text-center leading-relaxed place-self-center">i</div>
    <div class="col-span-11">
        <slot />
    </div>
</div>